import type { User } from '@/types'

// The guide-owned account status (tutorial-account-status): T01 for a signed-in user, read-only.
export default function AccountStatusCard({ user }: { user: User }) {
  const plan = user.is_trial ? `${user.subscription_tier} (trial)` : user.subscription_tier
  return (
    <section className="t0-account" data-tutorial-anchor="tutorial-account-status" aria-label="Account status">
      <h3 className="t0-account__title">Your account</h3>
      <dl className="t0-account__facts">
        <div><dt>Signed in as</dt><dd>{user.email}</dd></div>
        <div><dt>Email</dt><dd>{user.is_verified ? 'Verified' : 'Not verified yet'}</dd></div>
        <div><dt>AI disclosure</dt><dd>{user.ai_disclosure_accepted_at ? 'Accepted' : 'Not accepted yet'}</dd></div>
        <div><dt>Plan</dt><dd>{plan}</dd></div>
      </dl>
    </section>
  )
}
